module.exports = __webpack_public_path__ + "img/case21.4015e2ae.png";